/**
 * trialsConfig.js — Registro de simuladores públicos (frontend)
 *
 * Para agregar un nuevo simulador:
 * 1. Crear agente en /vertex/builder → copiar agentId
 * 2. Agregar trialKey aquí con la config visual
 * 3. Agregar la misma trialKey en publicTrialConfig.js (backend 3004)
 * 4. Agregar ruta pública en App.jsx
 */
export const TRIALS_CONFIG = {
  b2b: {
    trialKey: 'b2b',
    title: 'Simulador B2B',
    subtitle: 'Negociación con comité comprador bajo presión',
    // Panel izquierdo — tensiones del caso
    tensions: [
      { area: 'CFO', issue: 'ROI en corto plazo' },
      { area: 'CTO', issue: 'Esfuerzo de integración' },
      { area: 'Sponsor', issue: 'Posición debilitada internamente' },
    ],
    // Bloque de estado antes del chat
    blockedDecision: {
      label: 'DECISIÓN BLOQUEADA',
      description: 'No hay consenso interno para avanzar. Tu rol: destrabar la decisión.',
    },
    // Label del interlocutor en el chat
    clientLabel: 'Cliente — Comité comprador',
    // Resultado al finalizar
    outcome: {
      label: 'La decisión no avanzó.',
      description: 'No se logró alinear a finanzas y tecnología. La conversación no generó una base clara para decidir.',
      footnote: 'Esto es lo que ocurre en decisiones B2B reales.',
    },
    ctaHeadline: 'Entrena escenarios reales con presión ejecutiva.',
    ctaText: '¿Quieres continuar practicando? Crea tu cuenta gratis.',
    ctaButtonText: 'Crear cuenta gratuita y seguir entrenando',
    ctaLink: '/register',
    maxTurns: 3,
  }
  // startup: { ... }
};
